"use client";
import { useEffect, useState } from "react"
import { useLanguage } from "@/app/utils/LanguageContext";
import { getLocalRemark } from "@/app/utils/request/requestList";
import "./remarks.scss";
const Remarks = (props:any) => {
    const [remarks, setremarks] = useState('');
    const { state: lang } = useLanguage();

    useEffect(() => {
        getLocalRemark(props?.path, lang?.langCode, props?.hideAdditionalRemark ?? false)
        .then((res: any) => {
          console.log('get_Local_Remark', res)
          setremarks(res);
        })
    }, [])
    return <div className={`Bau_h_Style ${props?.customClass}`} style={props?.customStyle} dangerouslySetInnerHTML={{ __html: remarks }}/>
}

export default Remarks;